import React, { ReactNode, useState } from "react";

import "./faqElement.css";
import ChevronIcon from "../assets/icons/chevronIcon";

interface FAQElementProps {
    title: string;
    content: ReactNode;
}

export default function FAQElement(props: FAQElementProps) {

    const [open, setOpen] = useState(false);

    return (
        <div className={"faq-element" + (open ? " open" : "")}>
            <h2 onClick={() => setOpen(!open)}>{props.title}<ChevronIcon/></h2>
            <p>{props.content}</p>
        </div>
    );

}